import Web3 from "web3";
import {
  PHNX_STAKING_ABI,
  PHNX_STAKING_ADDRESS,
} from "../../contracts/phnxStaking";
import { ERC20_ABI } from "../../contracts/erc20";
import { phnxTokenAddress } from "../../contracts";

export default class ContractInit {
  static init = async () => {
    try {
      if (!this.web3js) {
        this.web3js = new Web3(window.web3.currentProvider);
      }
      this.accounts = await this.web3js.eth.getAccounts();
      // this.getNetwork = await this.web3js.eth.net.getNetworkType();
      this.getNetwork = await this.web3js.eth.net.getId();

      // console.log("abcc", this.getNetwork);

      return {
        web3js: this.web3js,
        address: this.accounts[0],
        network: this.getNetwork,
      };
    } catch (e) {
      console.error("ERROR init => ", e);
    }
  };

  static initPhnxTokenContract = async () => {
    try {
      if (!this.web3js) {
        await this.init();
      }
      this.phnxTokenContract = new this.web3js.eth.Contract(
        ERC20_ABI,
        phnxTokenAddress
      );

      return this.phnxTokenContract;
    } catch (e) {
      console.error("ERROR initPhnxTokenContract => ", e);
    }
  };

  static initPhnxStakingContract = async () => {
    try {
      if (!this.web3js) {
        await this.init();
      }
      this.phnxContract = new this.web3js.eth.Contract(
        PHNX_STAKING_ABI,
        PHNX_STAKING_ADDRESS
      );

      return this.phnxContract;
    } catch (e) {
      console.error("ERROR initPhnxStakingContract => ", e);
    }
  };
}
